import React from 'react';
import PrimaryButton from '../button/PrimaryButton';
import './HeroSection.css';

/**
 * HeroSection Component
 * Reusable hero section structure with title, subtitle, button, and visual content
 * 
 * @param {string} title - Hero title
 * @param {string} subtitle - Hero subtitle/description
 * @param {string} buttonText - Button text
 * @param {function} onButtonClick - Button click handler
 * @param {ReactNode} visual - Visual content (e.g., demo, image)
 * @param {string} className - Additional CSS classes
 */
const HeroSection = ({ 
  title, 
  subtitle, 
  buttonText, 
  onButtonClick, 
  visual,
  className = '' 
}) => {
  return (
    <section className={`hero-section ${className}`}>
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-text">
            <div className="hero-header">
              <h1 className="hero-title">{title}</h1>
              {buttonText && (
                <PrimaryButton onClick={onButtonClick}>
                  {buttonText}
                </PrimaryButton>
              )}
            </div>
            {subtitle && (
              <p className="hero-subtitle">{subtitle}</p>
            )}
          </div>
          
          {visual && (
            <div className="hero-visual">
              <div className="demo-container">{visual}</div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;























